export default __webpack_public_path__ + "static/media/download-svg.3177991e.svg";